
        var result = require("!!../css-loader/dist/cjs.js!./ol.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    